export const FEATURES = Object.freeze({
  // individual feature flags
  onDemand: 'onDemand',
  noAds: 'noAds',
  noEducation: 'noEducation',
  replaysEnabled: 'replaysEnabled',
  highQualityStreamingAvailable: 'highQualityStreamingAvailable',
  adFreeReplay: 'adFreeReplay',
  adSupportedReplay: 'adSupportedReplay',
  adFreeSkip: 'adFreeSkip',
  adSupportedSkip: 'adSupportedSkip',
  seenWebPremiumWelcome: 'seenWebPremiumWelcome',
  canSubscribe: 'canSubscribe',

  // user info flags
  vendorBilled: 'vendorBilled',
  isAdvertiser: 'isAdvertiser',
  expiredSubscriber: 'expiredSubscriber',
  expiredPremiumSubscriber: 'expiredPremiumSubscriber',
  registeredOnRedesign: 'registeredOnRedesign',
} as const);
